import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const hasProcessed = useRef(false);
    const [err, setErr] = useState(null);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = location.hash || window.location.hash;
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login");
            return;
        }
        const session_id = m[1];
        (async () => {
            try {
                const r = await api.post("/auth/session", { session_id });
                navigate("/dashboard", { state: { user: r.data } });
            } catch (e) {
                setErr("Gagal verifikasi. Coba lagi ya, Kak.");
                setTimeout(() => navigate("/login"), 2000);
            }
        })();
    }, [location, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#0A1A2F] text-white" data-testid="auth-callback">
            <div className="text-center">
                <Loader2 className="w-10 h-10 mx-auto animate-spin text-[#F5A623]" />
                <p className="mt-4 text-sm">{err || "Sedang memverifikasi, Kak..."}</p>
            </div>
        </div>
    );
}
